import parse from 'html-react-parser';

import { cme_kurs } from './Global/Kurs';
import { isOnServer } from './Global/constants'

export const Answer = ({ answerIndex, questionIndex, answer, rawAnswers, setRawAnswers, setAnswerKey }) => {

    function selectAnswer(event) {

        // -- do nothing if app in offline-mode or course is not active
        if (isOnServer && cme_kurs.active) {

            // -- set rawAnswers at this position
            var newRawAnswers = [...rawAnswers];
            newRawAnswers[questionIndex] = answerIndex;
            setRawAnswers(newRawAnswers);

            // -- set answerKey
            formatAnswers(newRawAnswers);

            // -- handle checkboxes
            var single_answer = event.currentTarget;
            var answers_container = single_answer.parentNode;

            // reset selected answers
            var allCheckboxes = answers_container.querySelectorAll(".answer-rect-container");
            allCheckboxes.forEach(elem => {
                elem.classList.remove("answer-selected");
                elem.classList.add("answer-rect");
            });

            // select clicked answer
            var thisCheckbox = single_answer.querySelector(".answer-rect-container");
            thisCheckbox.classList.toggle("answer-selected");
            thisCheckbox.classList.toggle("answer-rect");

        }
    }


    // -- format answer array for proper post-request
    function formatAnswers(answers) {

        var correctFormat = "";

        // -- set AnswerKey for BACKEND
        for (let i = 0; i < answers.length; i++) {
            const thisAnswer = answers[i];
            switch (thisAnswer) {
                case 0:
                    correctFormat += "A";
                    break;
                case 1:
                    correctFormat += "B";
                    break;
                case 2:
                    correctFormat += "C";
                    break;
                case 3:
                    correctFormat += "D";
                    break;
                case 4:
                    correctFormat += "E";
                    break;
                case null:
                    correctFormat += "x";
                    break;
                case undefined:
                    correctFormat += "x";
                    break;

                default:
                    break;
            }
        }

        setAnswerKey(correctFormat);
    }


    return (
        <>
            {/* anser-rect -> unchecked */}
            {/* answer-selected -> checked */}
            <div className="single-answer" onClick={selectAnswer}>

                <div
                    style={(isOnServer && cme_kurs.active) ? {} : { backgroundImage: "none", padding: 0 }}

                    // check rawAnswers if this answer is selected
                    className={rawAnswers[questionIndex] === answerIndex ? "answer-rect-container answer-selected" : "answer-rect-container answer-rect"}
                ></div>

                <div className="answer-text">{parse(answer)}</div>

            </div>
        </>
    )
}

export default Answer